import { Controller } from "@hotwired/stimulus"

// Handles password field visibility toggling
// Usage:
//   <div data-controller="crud--password-field" data-action="input->crud--password-field#toggleEye">
//     <input type="password" data-crud--password-field-target="input">
//     <button data-crud--password-field-target="eyeButton" data-action="click->crud--password-field#toggle">
//       <span data-crud--password-field-target="showIcon"><!-- eye icon --></span>
//       <span data-crud--password-field-target="hideIcon" class="hidden"><!-- eye-slash icon --></span>
//     </button>
//   </div>
export default class extends Controller {
  static targets = ["input", "eyeButton", "showIcon", "hideIcon"]

  connect() {
    this.toggleEye()
  }

  toggleEye() {
    const hasValue = this.inputTarget.value.length > 0
    this.eyeButtonTarget.classList.toggle("hidden", !hasValue)
  }

  toggle(event) {
    event.preventDefault()
    const isPassword = this.inputTarget.type === "password"
    this.inputTarget.type = isPassword ? "text" : "password"
    this.showIconTarget.classList.toggle("hidden", isPassword)
    this.hideIconTarget.classList.toggle("hidden", !isPassword)
  }
}
